module.exports = __webpack_public_path__ + "static/webhook-url-94868850d61e2998caa2ce4d18b82b08.png";